import { LAYOUT_PAGE__base } from '@/page_wrappers/LAYOUT_PAGE__base';
import { PAGE__error } from '@/pages/page_system/PAGE__error';

export function ROUTE__base(path: string, element: React.ReactNode) {
  return {
    path,
    element: <LAYOUT_PAGE__base page_type={path} page={element} />,
    errorElement: <PAGE__error />,
  };
}
